import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";

type VideoThumbnailProps = {
  thumbnailImage?: Content.Asset;
  fallbackUrl?: string;
  className?: string;
  imagePriority?: boolean;
};

const VideoThumbnail = (props: VideoThumbnailProps) => {
  if (props.thumbnailImage?.fields?.file?.url) {
    return (
      <div className={props.className || "aspect-w-16 aspect-h-9"}>
        <Image
          priority={props.imagePriority ? true : false}
          fill
          src={createImageUrl(props.thumbnailImage.fields.file.url, {
            crop: "16:9",
          })}
          alt={props.thumbnailImage.fields.alt || ""}
          className="object-cover"
          sizes={createImageSizes({
            mobile: "50vw",
            tablet: "50vw",
            desktop: "33vw",
          })}
        />
      </div>
    );
  }

  if (props.fallbackUrl) {
    return (
      <div className={props.className || "aspect-w-16 aspect-h-9"}>
        <Image
          fill
          src={createImageUrl(props.fallbackUrl, { crop: "16:9" })}
          alt={""}
          className="object-cover"
          sizes={createImageSizes({
            mobile: "400px",
            tablet: "700px",
            desktop: "800px",
          })}
        />
      </div>
    );
  }

  return null;
};

export default VideoThumbnail;
